import React, { useEffect, useState } from 'react';
import Alert from '@mui/material/Alert';
import { Close } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import { PropTypes } from 'prop-types';

  // Parametros props
  //open: si se ve o no el mensaje 
  //severity: tipo de mensaje  {/* severity: error,  warning, info, success*/}
  //msg: Mensaje a Mostrar
  //CloseAlert: Cerrar el Modal

SimpleAlerts.propTypes = {
  open: PropTypes.bool.isRequired,
  severity: PropTypes.string.isRequired,
  msg: PropTypes.string.isRequired,
  closeAlert: PropTypes.func.isRequired,
  segundos: PropTypes.number.isRequired,
};

SimpleAlerts.defaultProps = {  
  open: false,
  severity: "success",
  msg: '',
  closeAlert: ()=>{ console.log("Cerrando")},
  segundos: 6,
}  


function SimpleAlerts (props) {
  
  //GUADA EN UN HOOK LOS VALORES
  const [alert, setAlert] = useState(props);
  var timer;

  function handleStatusChange(props) {
    setAlert(props);
  }

  useEffect(() => {
    handleStatusChange(props);
    const duracion = props.segundos * 1000;

    if(alert.msg !== ''){
      timer = setTimeout(() => { 
        props.closeAlert();
      },duracion);//SEGUNDOS
    }
    
    return () => {
        // console.log("Desmontando Alert");
        clearTimeout(timer);
    };
  });

  if(alert.msg !== ''){
    return (
      <Alert
        className='Alert' 
          color={props.severity}
          open={props.open} 
          severity={props.severity} 
          action={
      <IconButton aria-label="close" 
                  style={{margin: '0 auto'}} 
                  color="inherit" 
                  size="small" 
                  onClick={() => {props.closeAlert()}}>
        <Close fontSize="inherit" />
      </IconButton>
    }>
        {props.msg}
      </Alert>
    );
  } 
  else 
    return (<></>);
}

/* retorna true si al pasar los nextProps a renderizar retorna el mismo resultado que al pasar los prevProps a renderizar, de otro modo retorna false */
// function validaProps(prevProps, nextProps) {
//   // console.log(equalarray(prevProps.poliza, nextProps, (prevProps.value === nextProps.value), (JSON.stringify(prevProps.poliza[0]) === JSON.stringify(nextProps.poliza[0]))); 
//   //si retorna un falso renderiza todo el componente, porque si es falso significa que el valor cambio
//   //falso es igual que son diferentes
//   //si son muchos objetos va si [0]
//   return (prevProps.msg === nextProps.msg);
// }

// export default SimpleAlerts;
export default React.memo(SimpleAlerts);
